import { CoreStatus, CoreSubstatus } from "@tc/graphql-server"
import { defaultSubstatusLabel } from "./substatus-label-mapper"

export interface StatusLabel {
  value: (status: CoreStatus) => string
}

// DFE status label mapping - used on list view page
export const status_label: Record<CoreStatus, string> = {
  [CoreStatus.Amended]: "Amended",
  [CoreStatus.Approved]: "Approved",
  [CoreStatus.Cancelled]: "Cancelled",
  [CoreStatus.Draft]: "Draft",
  [CoreStatus.Raised]: "Raised",
  [CoreStatus.Replaced]: "Replaced",
  [CoreStatus.RequestAmendment]: "Request amendment",
  [CoreStatus.Resubmit]: "Resubmit",
  [CoreStatus.Revoked]: "Revoked",
  [CoreStatus.ToBeAmended]: "To be amended",
  [CoreStatus.PendingReplacement]: "Pending Replacement",
  [CoreStatus.Acknowledged]: "Acknowledged",
  [CoreStatus.Accepted]: "Accepted",
  [CoreStatus.Detained]: "Detained",
  [CoreStatus.Rejected]: "Rejected",
  [CoreStatus.Partial]: "Partial",
  [CoreStatus.RequestReplacement]: "Replacement Requested",
}

const createStatusLabel = (
  mapping: Record<CoreStatus, string>,
): StatusLabel => ({
  value: (status: CoreStatus) => mapping[status],
})

export const defaultStatusLabel = createStatusLabel(status_label)

/**
 * Generates a status label with optional substatus
 * @param status - The core status
 * @param substatus - Optional substatus
 * @returns Combined status label string
 */
export const generateStatusLabel = (
  status: CoreStatus,
  substatus?: CoreSubstatus | null,
): string => {
  const statusLabel = defaultStatusLabel.value(status) ?? ""

  if (substatus && [CoreStatus.Amended, CoreStatus.Raised].includes(status)) {
    const substatusLabel = defaultSubstatusLabel.value(substatus)
    return `${statusLabel} - ${substatusLabel}`
  }

  return statusLabel
}
